var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 43.5,
    stroke: "#B7B7B7",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0547 47.5C62.0547 60.2479 60.0292 71.607 56.8943 79.6322C55.322 83.6572 53.5487 86.6424 51.7838 88.5534C50.0228 90.4601 48.5713 91 47.5 91C46.4287 91 44.9772 90.4601 43.2162 88.5534C41.4513 86.6424 39.678 83.6572 38.1057 79.6322C34.9708 71.607 32.9453 60.2479 32.9453 47.5C32.9453 34.7521 34.9708 23.393 38.1057 15.3678C39.678 11.3428 41.4513 8.35765 43.2162 6.44664C44.9772 4.53991 46.4287 4 47.5 4C48.5713 4 50.0228 4.53991 51.7838 6.44664C53.5487 8.35765 55.322 11.3428 56.8943 15.3678C60.0292 23.393 62.0547 34.7521 62.0547 47.5Z",
    stroke: "#B7B7B7",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 37.4803C37.7027 29.1288 56.0445 29.0095 89.7914 37.4803",
    stroke: "#B7B7B7",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5337 59.3749C58.7685 67.7264 40.4267 67.8457 6.67975 59.3749",
    stroke: "#B7B7B7",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.282dbe69729a1b40829a779d79408f33.svg";
export { ForwardRef as ReactComponent };